import { instance } from '@/services/avik-api-gateway'
import { VehicleWithdrawalResponsible } from '@/types/vehicle-withdrawal-responsible'
import { AxiosResponse } from 'axios'

export function getVehicleWithdrawalResponsibles(): Promise<
  AxiosResponse<VehicleWithdrawalResponsible[]>
> {
  return instance.get(`/vehicle-withdrawal-responsible`)
}
